import { ApiProperty } from '@nestjs/swagger';
import { Exclude, Expose } from 'class-transformer';
import { RepairPaymentEmailInterface } from '../interfaces/repair-payment-email.interface';

@Exclude()
export class RepairPaymentEmailDto implements RepairPaymentEmailInterface {
  @ApiProperty({
    title: 'Lot',
    description: 'The lot number/identifier',
  })
  @Expose()
  jobLot!: string;

  @ApiProperty({
    title: 'Block',
    description: 'The block number/identifier',
  })
  @Expose()
  jobBlock!: string;

  @ApiProperty({
    title: 'Subdivision name',
    description: 'The subdivision name associated with this jobRepair',
  })
  @Expose()
  subdivisionName!: string;

  @ApiProperty({
    title: 'Builder Name',
  })
  @Expose()
  builderName!: string;

  @ApiProperty({
    title: 'Supervisor full name',
    description: 'The supervisor full name associated with this jobRepair',
  })
  @Expose()
  supervisorName!: string;

  @ApiProperty({
    title: 'Logo URL',
  })
  @Expose()
  logoUrl!: string;

  @ApiProperty({
    title: 'Job Repair Date',
  })
  @Expose()
  createAt!: Date;

  @ApiProperty({
    title: 'Today Date',
  })
  @Expose()
  todayDate!: string;

  @ApiProperty({
    title: 'Created Date',
  })
  @Expose()
  createdDate!: string;
}
